import type { TeamMember } from "../types/index";

export const teamMembers: TeamMember[] = [
  {
    id: 1,
    name: "Suhaimi Mohamad",
    position: "Travel Director",
    whatsapp: "+64221841601",
    bio: "With over 10 years in the travel industry, Suhaimi is an expert in managing comprehensive tours across New Zealand. His extensive experience ensures every journey is seamlessly executed and truly memorable for all travellers.",
    profileImage: "/placeholder-profile1.jpg",
    displayOnContact: true,
    displayOnAbout: true,
  },
  {
    id: 2,
    name: "Nadia Suhaimi",
    position: "Operations Manager",
    whatsapp: "+642040472102",
    bio: "Nadia is an expert in managing all aspects of tour operations with precision and care. She is passionate about creating exceptional travel experiences and ensuring every detail of each journey is perfectly executed.",
    profileImage: "/placeholder-profile2.jpg",
    displayOnContact: true,
    displayOnAbout: true,
  },
];
